import React, { useEffect, useRef } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import usePrevious from 'components/usePrevious';

// delete if doesn't work out
const ScrollToTopComp = ({ isVisible = false, currentQuestionIndex }) => {
  const dummyRef = useRef(null);
  const prevQuestionIndex = usePrevious(currentQuestionIndex);
  const isForward = prevQuestionIndex !== undefined && currentQuestionIndex > prevQuestionIndex;
  const isBackward = prevQuestionIndex !== undefined && currentQuestionIndex < prevQuestionIndex;

  useEffect(() => {
    if (!isVisible) return;
    if (isForward && dummyRef?.current) {
      dummyRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [isForward, isVisible, isBackward]);

  useEffect(() => {
    if (!isVisible) return;
    dummyRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, []);

  return (
    <Flex flexDir="column" height="100%" justifyContent="space-between">
      <Box ref={dummyRef} h="300px" maxWidth="1px" w="1px" bg="transparent" zIndex={1000} />
    </Flex>
  );
};

export default ScrollToTopComp;
